if (!customElements.get('product-discount-upsells')) {
  customElements.define(
    'product-discount-upsells',
    class ProductDiscountUpsells extends HTMLElement {
      connectedCallback () {
        this.addEventListener('change', this.onOptionChange.bind(this));
        this.selections = []
        this.maxUsages = parseInt(this.dataset.maxUsages)
      }

      onOptionChange(e) {
        if (!e.target.classList.contains('js-submit-check')) return;

        const productId = +e.target.value

        if (!e.target.checked) {
          this.selections = this.selections.filter(selection => selection !== productId)
        } else {
          if (this.selections.length < this.maxUsages) {
            this.selections = [...this.selections, productId]
          } else {
            const slidedSelections = this.selections.slice(1)
            this.selections = [...slidedSelections, productId]
          }
        }

        this.querySelectorAll('.js-submit-check').forEach(input => {
          input.checked = this.selections.includes(+input.value)
        })
      }
    })
}
